import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const ProgressBarStep = ({ children, className })=>jsx("div", {
        className: "cb-step",
        role: "stepDescription",
        children: jsx("div", {
            className: classNames('cb-step__content', className),
            children: children
        })
    });
ProgressBarStep.displayName = 'ProgressBar.Step';

export { ProgressBarStep };
//# sourceMappingURL=ProgressBar.Step.es.js.map
